import React, { FC, useCallback, useMemo } from 'react';
import { useScopedSelector } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { WelcomeBoxButton } from 'omni-package-react-core';
import { ReactComponent as NotificationIcon } from '../../assets/bell-button.svg';
import { setNotificationsIsOpened } from '../../actions/Notifications.actions';
import { Notification } from '../../interfaces/Notification';
import { NotificationsCountResourceInfo } from '../NotificationsCountResource/NotificationsCountResource';

export interface WelcomeBoxNotificationButtonProps { }

const WelcomeBoxNotificationButton: FC<WelcomeBoxNotificationButtonProps> = () => {
  const count: number = useScopedSelector(NotificationsCountResourceInfo.dataDst, 0);
  const promotions: Notification[] = useScopedSelector('/App.features.notifications.promotions', []);
  const filteredPromotions = useMemo(() => promotions?.filter((notification) => notification.id !== 'IA_CLIENT_SPACE'), [promotions]);
  const dispatch = useDispatch();
  const dispatchSetNotificationsIsOpened = useCallback(() => {
    dispatch(setNotificationsIsOpened());
  }, [dispatch]);

  const totalCount = useMemo(() => (count + (filteredPromotions?.length ?? 0)), [filteredPromotions, count]);
  if (totalCount > 0) {
    return (
      <WelcomeBoxButton
        data-testid="Notifications"
        LeftIcon={NotificationIcon}
        onClick={dispatchSetNotificationsIsOpened}
        count={totalCount}
        singular="notification"
        plural="notifications"
      />
    );
  }
  return null;
};
export default WelcomeBoxNotificationButton;
